<div>
  <div
    class="slack-message"
    style="margin: 10px 0"
    #editorWrapper
    [ngxTippy]="enableSlackMentions ? editorTooltipTemplate : null"
    [tippyProps]="tippyProps"
    tippyClassName="editor-tippy"
    [tippyName]="tippyName"
    [class.slack-mentions-enabled]="enableSlackMentions"
  ></div>
  <div class="toolbar">
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="insertVariable()"
      title="Variable"
      [hidden]="hideVariable"
      ><ion-icon name="custom-braces"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="insertEmoji()"
      title="Emoji"
      ><ion-icon name="happy-outline"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleBold()"
      title="Bold"
      ><ion-icon name="custom-bold"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleItalic()"
      title="Italic"
      ><ion-icon name="custom-italic"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleStrikethrough()"
      title="Strikethrough"
      [hidden]="hideStrikethrough"
      ><ion-icon name="custom-strikethrough"></ion-icon
    ></ion-button>
    <ion-button
      *ngIf="isRichText"
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleBulletList()"
      title="Bulleted list"
      ><ion-icon name="custom-unordered-list"></ion-icon
    ></ion-button>
    <ion-button
      *ngIf="isRichText"
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleOrderedList()"
      title="Ordered list"
      ><ion-icon name="custom-ordered-list"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleBlockquote()"
      title="Block quote"
      [hidden]="hideQuote"
      ><ion-icon name="custom-blockquote"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleInlineCode()"
      title="Code"
      [hidden]="hideCode"
      ><ion-icon name="custom-code-view"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="toggleCodeBlock()"
      title="Code block"
      [hidden]="hideCodeblock"
      ><ion-icon name="custom-code-block"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="addLink()"
      title="Add link"
      ><ion-icon name="custom-link"></ion-icon
    ></ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      color="dark"
      (click)="clearFormatting()"
      title="Clear format"
      ><ion-icon name="custom-format-clear"></ion-icon
    ></ion-button>
  </div>
</div>

<!-- Only render tooltip template if Slack mentions are enabled and we have an active search mode -->
<ng-template
  #editorTooltipTemplate
  *ngIf="enableSlackMentions && autocompleteSearchMode !== 'none'"
>
  <ion-list
    class="transparent-bg tooltip-list"
    lines="none"
    *ngIf="autocompleteSearchMode === 'users'"
  >
    <ion-item
      *ngFor="let user of taggableUsers; let i = index"
      (click)="selectTaggedUser(user)"
      button="true"
      class="ion-item-rounded"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <app-avatar
        size="22"
        [style.height]="'22px'"
        [style.width]="'22px'"
        [style.margin]="'0 5px 0 -5px'"
        slot="start"
        [name]="user.name"
        [image]="user.image"
      >
      </app-avatar>
      <ion-label>
        {{ user.name }}
        <p *ngIf="user.email">
          {{ user.email }}
        </p>
      </ion-label>
    </ion-item>

    <div class="flexed-align-center" *ngIf="!taggableUsers">
      <ion-skeleton-text
        animated
        style="width: 22px; height: 22px; border-radius: 50%; margin-right: 5px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        animated
        style="
          width: 182px;
          height: 16px;
          border-radius: 4px;
          margin-right: 5px;
        "
      ></ion-skeleton-text>
    </div>

    <ion-item *ngIf="taggableUsers && taggableUsers.length === 0">
      No users found
    </ion-item>
  </ion-list>

  <!-- Team selection list -->
  <ion-list
    class="transparent-bg tooltip-list"
    lines="none"
    *ngIf="autocompleteSearchMode === 'teams'"
  >
    <ion-item class="mention-header">
      <ion-label>
        <h3>Select a workspace:</h3>
      </ion-label>
    </ion-item>
    <ion-item
      *ngFor="let team of taggableTeams; let i = index"
      (click)="selectTeamForMentions(team)"
      button="true"
      class="ion-item-rounded"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-label>
        {{ team.name }}
      </ion-label>
    </ion-item>

    <ion-item *ngIf="taggableTeams && taggableTeams.length === 0">
      No workspaces found
    </ion-item>
  </ion-list>

  <!-- Channel selection list -->
  <ion-list
    class="transparent-bg tooltip-list"
    lines="none"
    *ngIf="autocompleteSearchMode === 'channels'"
  >
    <ion-item class="mention-header" *ngIf="connectedTeams?.length > 1">
      <ion-label>
        <ion-button fill="clear" size="small" (click)="goBackToTeamSelection()">
          <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
          Back
        </ion-button>
      </ion-label>
    </ion-item>
    <ion-item
      *ngFor="let channel of taggableChannels; let i = index"
      (click)="selectTaggedChannel(channel)"
      button="true"
      class="ion-item-rounded"
      [ngClass]="{ highlighted: i === highlightedItemIndex }"
    >
      <ion-label>
        <ion-icon
          *ngIf="channel.isPrivate"
          name="lock-closed-outline"
          slot="start"
          style="margin-right: 4px; color: var(--ion-color-step-600)"
        ></ion-icon>
        <span *ngIf="!channel.isPrivate">#</span>
        {{ channel.name }}
      </ion-label>
    </ion-item>

    <div class="flexed-align-center" *ngIf="!taggableChannels">
      <ion-skeleton-text
        animated
        style="width: 22px; height: 22px; border-radius: 4px; margin-right: 8px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        animated
        style="
          width: 182px;
          height: 16px;
          border-radius: 4px;
          margin-right: 5px;
        "
      ></ion-skeleton-text>
    </div>

    <ion-item *ngIf="taggableChannels && taggableChannels.length === 0">
      No channels found
    </ion-item>
  </ion-list>
</ng-template>
